import React, { ReactNode } from 'react'
import { ErrorBoundary } from './ErrorBoundary'
import { LoadingSpinner } from './LoadingSpinner'

interface AppContainerProps {
  children: ReactNode
  loading?: boolean
  error?: Error | null
  onRetry?: () => void
}

export const AppContainer: React.FC<AppContainerProps> = ({
  children,
  loading = false,
  error = null,
  onRetry,
}) => {
  if (loading) {
    return (
      <div className="app-container app-container--loading">
        <LoadingSpinner />
      </div>
    )
  }

  if (error) {
    return (
      <div className="app-container app-container--error">
        <div className="error-message">
          <h2>Something went wrong</h2>
          <p>{error.message}</p>
          {onRetry && (
            <button onClick={onRetry} className="retry-button">
              Try Again
            </button>
          )}
        </div>
      </div>
    )
  }

  return (
    <ErrorBoundary>
      <div className="app-container">
        {children}
      </div>
    </ErrorBoundary>
  )
}